export default "__VITE_ASSET__754904bc__"